import {
  Box,
  Button,
  Card,
  CircularProgress,
  Divider,
  Drawer,
  Typography,
} from "@mui/material";
import { useMutation, useQuery } from "react-query";
import { useNavigate } from "react-router-dom";
import { useMemo, useState } from "react";
import { usersWithBusinessRoles, rolesEdit } from "../../api/api";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import PersonAddIcon from "@mui/icons-material/PersonAdd";
import { AgGridReact } from "ag-grid-react";
import { ColDef } from "ag-grid-community";
import * as Yup from "yup";
import { FastField, Field, Form, Formik } from "formik";
import FormGroup from "@mui/material/FormGroup";
import { CheckboxWithLabel, TextField } from "formik-mui";
import DoneIcon from "@mui/icons-material/Done";
import { useMedia } from "react-use";
import React from "react";
import { BusinessUser } from "../../api/types";
import { roleTypes } from "../../constants";

export const Permissions = ({
  selectedBusiness,
}: {
  selectedBusiness: any;
}) => {
  const [registerError, setRegisterError] = useState<any>();
  const [open, setOpen] = useState(false);
  const navigate = useNavigate();

  const [rightDrawerOpen, setRightDrawerOpen] = useState(false);
  const [alertOpen, setAlertOpen] = useState(false);
  const [alertTitle, setAlertTitle] = useState("");
  const [alertMessage, setAlertMessage] = useState("");
  const [selectedUser, setSelectedUser] = useState<BusinessUser | null>(null);
  const isWide = useMedia("(min-width: 1600px)");

  const alert = (title, message) => {
    setAlertTitle(title);
    setAlertMessage(message);
    setAlertOpen(true);
  };

  /*
  const { data: getUserAdminOfBusinessesResponse } = useQuery(
    'getUserAdminOfBusinesses',
    getUserAdminOfBusinesses,
    {
      enabled: true,
      refetchOnWindowFocus: false,
      suspense: true,
    },
  );

  const userAdminOfBusinesses = getUserAdminOfBusinessesResponse!.data;

  const [selectedBusinessId, setSelectedBusinessId] = useState<number>(
    userAdminOfBusinesses[0]?.id,
  );
  */

  console.log(selectedBusiness);

  const {
    data: response,
    isLoading,
    isFetching,
    error,
    refetch,
  } = useQuery(
    ["usersWithBusinessRoles", selectedBusiness?.id],
    usersWithBusinessRoles(selectedBusiness?.id),
    {
      enabled: !!selectedBusiness,
      refetchOnWindowFocus: false,
    }
  );
  const data = response?.data;

  const {
    mutateAsync,
    error: mutateError,
    data: mutateData,
    isLoading: mutateIsLoading,
  } = useMutation("rolesEdit", rolesEdit, {
    onError: (err: any) => {
      alert("Error", err.message);
    },
  });

  const { columnDefs, rowData } = useMemo(() => {
    if (!data?.length) {
      return { rowData: [] };
    }
    const columnDefs: ColDef[] = [
      {
        field: "email",
        headerName: "Email",
        sortable: true,
        // eslint-disable-next-line sonarjs/no-duplicate-string
        headerClass: "horizontal-text",
        flex: 3,
        minWidth: 210,
        filter: true,
      },
      {
        field: "familyName",
        headerName: "Family name",
        sortable: true,
        headerClass: "horizontal-text",
        flex: 2,
        minWidth: 110,
        filter: true,
      },
      {
        field: "givenName",
        headerName: "Given name",
        sortable: true,
        headerClass: "horizontal-text",
        flex: 2,
        minWidth: 110,
        filter: true,
      },
      {
        field: "TICKET_CHECKER",
        headerName: "Ticket checker",
        sortable: true,
        // eslint-disable-next-line sonarjs/no-duplicate-string
        headerClass: "ag-narrow ag-wrap",
        cellClass: "ag-narrow",
        flex: 1,
        minWidth: 70,
        cellRenderer: ({ data }) => {
          return data.roles.some((r) => r.type === "TICKET_CHECKER") ? (
            <DoneIcon />
          ) : (
            ""
          );
        },
      },
      {
        field: "TICKET_INVALIDATOR",
        headerName: "Ticket invalidator",
        sortable: true,
        headerClass: "ag-narrow ag-wrap",
        cellClass: "ag-narrow",
        flex: 1,
        minWidth: 70,

        cellRenderer: ({ data }) => {
          return data.roles.some((r) => r.type === "TICKET_INVALIDATOR") ? (
            <DoneIcon />
          ) : (
            ""
          );
        },
      },
      {
        field: "EVENT_REPORTER",
        headerName: "Event reporter",
        sortable: true,
        headerClass: "ag-narrow ag-wrap",
        cellClass: "ag-narrow",
        flex: 1,
        minWidth: 70,

        cellRenderer: ({ data }) => {
          return data.roles.some((r) => r.type === "EVENT_REPORTER") ? (
            <DoneIcon />
          ) : (
            ""
          );
        },
      },
      {
        field: "EVENT_CREATOR",
        headerName: "Event creator",
        sortable: true,
        headerClass: "ag-narrow ag-wrap",
        cellClass: "ag-narrow",
        flex: 1,
        minWidth: 70,

        cellRenderer: ({ data }) => {
          return data.roles.some((r) => r.type === "EVENT_CREATOR") ? (
            <DoneIcon />
          ) : (
            ""
          );
        },
      },
      {
        field: "EVENT_CONFIGURATOR",
        headerName: "Event configurator",
        sortable: true,
        headerClass: "ag-narrow ag-wrap",
        cellClass: "ag-narrow",
        flex: 1,
        minWidth: 70,
        cellRenderer: ({ data }) => {
          return data.roles.some((r) => r.type === "EVENT_CONFIGURATOR") ? (
            <DoneIcon />
          ) : (
            ""
          );
        },
      },
      {
        field: "BUSINESS_ADMIN",
        headerName: "Business admin",
        sortable: true,
        headerClass: "ag-narrow ag-wrap",
        cellClass: "ag-narrow",
        flex: 1,
        minWidth: 70,
        cellRenderer: ({ data }) => {
          return data.roles.some((r) => r.type === "BUSINESS_ADMIN") ? (
            <DoneIcon />
          ) : (
            ""
          );
        },
      },
    ];

    return { columnDefs, rowData: data };
  }, [data]);

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <>
      <React.Fragment key="right">
        <Drawer
          anchor="right"
          open={rightDrawerOpen}
          onClose={() => {
            refetch();
            setRightDrawerOpen(false);
          }}
        >
          <Box sx={{ width: { xs: "100vw", sm: "600px" } }}>
            <Typography
              variant="h1"
              sx={{ fontSize: "1.3em", fontWeight: 500, m: "16px 24px" }}
            >
              Edit permissions
            </Typography>
            <Divider />
            <Box sx={{ padding: "24px" }}>
              <Box sx={{ mb: "16px" }}>
                <Typography sx={{ fontWeight: 500, display: "inline" }}>
                  Business:{" "}
                </Typography>
                {selectedBusiness?.name}
              </Box>
              {!!selectedUser && (
                <Box sx={{ mb: "16px" }}>
                  <Typography sx={{ fontWeight: 500, display: "inline" }}>
                    User:{" "}
                  </Typography>
                  {selectedUser?.email}
                </Box>
              )}

              {!selectedUser &&
                "Enter the email address of the registered user you want give permission to the business."}
              <Formik
                validateOnMount
                initialValues={{
                  email: selectedUser?.email || "",
                  types: selectedUser?.roles.map((r) => r.type),
                }}
                validationSchema={Yup.object().shape({
                  email: Yup.string()
                    .email("Invalid email")
                    .required("Required"),
                })}
                onSubmit={async (values: any, { setSubmitting }) => {
                  values.businessId = selectedBusiness.id;
                  try {
                    await mutateAsync({ values });
                  } catch (error: any) {
                    alert(error.error, error.message);
                  }
                  refetch();
                  setSubmitting(false);
                  setRightDrawerOpen(false);
                }}
              >
                {({
                  submitForm,
                  isSubmitting,
                  values,
                  isValid,
                  handleChange,
                  errors,
                  touched,
                  handleBlur,
                }) => (
                  <Form style={{ width: "100%" }}>
                    <Box
                      sx={{
                        width: "100%",
                        marginInline: "auto",
                        display: "flex",
                        flexDirection: "column",
                        gap: 2,
                        position: "relative",
                      }}
                    >
                      <FastField
                        component={TextField}
                        label="Email address"
                        name="email"
                        type="email"
                        size="small"
                        sx={{
                          mt: 3,
                          ...(!!selectedUser && { display: "none" }),
                        }}
                      />

                      <FormGroup>
                        {roleTypes.map((roleType) => {
                          return (
                            <>
                              <Field
                                key={roleType.id}
                                component={CheckboxWithLabel}
                                type="checkbox"
                                name="types"
                                value={roleType.id}
                                Label={{ label: roleType.label }}
                              />
                              <Typography
                                sx={{
                                  opacity: "0.6",
                                  mt: "-5px",
                                  mb: "6px",
                                  fontSize: "0.75rem",
                                }}
                              >
                                {roleType.helperText}
                              </Typography>
                            </>
                          );
                        })}
                      </FormGroup>

                      <Box
                        sx={{
                          textAlign: "right",
                          margin: "16px 0",
                          display: "flex",
                          flexDirection: "row",
                        }}
                      >
                        <Button
                          color="primary"
                          disabled={isSubmitting}
                          onClick={() => setRightDrawerOpen(false)}
                          sx={{ padding: "6px 8px" }}
                        >
                          Cancel
                        </Button>

                        <Box sx={{ flex: "1 1 auto" }} />
                        <Button
                          color="primary"
                          variant="contained"
                          disabled={isSubmitting || !isValid}
                          sx={{ padding: "6px 24px" }}
                          onClick={submitForm}
                        >
                          Save
                        </Button>
                      </Box>
                    </Box>
                  </Form>
                )}
              </Formik>
            </Box>
          </Box>
        </Drawer>
      </React.Fragment>
      <Dialog
        open={alertOpen}
        onClose={() => setAlertOpen(false)}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">{`${alertTitle}`}</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            {`${alertMessage}`}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setAlertOpen(false)}>OK</Button>
        </DialogActions>
      </Dialog>

      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          flexGrow: "1",
        }}
      >
        <Box
          sx={{
            display: "flex",
            flexDirection: "row",
            flexGrow: 0,
            alignItems: "center",
            gap: 1,
            height: "56px",
          }}
        >
          <Typography
            variant="h4"
            component="h2"
            sx={{
              fontSize: "1.25rem",
            }}
          >
            Permissions
          </Typography>
          <Button
            color="primary"
            onClick={() => {
              setSelectedUser(null);
              setRightDrawerOpen(true);
            }}
          >
            <PersonAddIcon sx={{ ml: -0.5, mr: 0.5 }} />
            Add new
          </Button>
        </Box>
        <Card
          className="ag-theme-material"
          sx={{
            borderRadius: 0,
            margin: "0 -16px -16px",
            display: "flex",
            overflow: "hidden",
            flexGrow: 1,
            height: "100%",
            boxShadow: "none !important",
          }}
        >
          {isFetching && (
            <Box
              sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                height: "100%",
              }}
            >
              <CircularProgress />
            </Box>
          )}

          <Box sx={{ display: isFetching ? "none !important" : "block" }}>
            <AgGridReact
              className={"ag-pointer-row"}
              rowData={rowData}
              pagination={true}
              floatingFiltersHeight={50}
              paginationAutoPageSize={true}
              columnDefs={columnDefs}
              onRowClicked={({ data }) => {
                setSelectedUser(data);
                setRightDrawerOpen(true);
              }}
            ></AgGridReact>
          </Box>
        </Card>
      </Box>
    </>
  );
};

export default Permissions;
